import {
  Box,
  Card,
  Divider,
  Skeleton,
  Stack
} from '@mui/material';

const TABLE_COLUMNS = 7;
const TABLE_ROWS = 10;

export const HomeSkeletonFallback = () => {
  return (
    <Box className="min-h-full h-full w-full bg-gray-100 p-6">
      {/* ===================== BODY ===================== */}
      <Box className="h-full !px-65" sx={{ display: 'flex', gap: 2, p: 2 }}>
        {/* -------- LEFT: TABLE -------- */}
        <Card className="!rounded-xl" sx={{ flex: 3.5, p: 2 }}>
          <Skeleton variant="text" width={160} height={48} />
          <Skeleton variant="text" width={260} height={36} className="mb-4" />

          <Divider className="mb-4" />
          {/* Table Header */}
          <Stack direction="row" spacing={2} mb={2}>
            {Array.from({ length: TABLE_COLUMNS }).map((_, index) => (
              <Skeleton
                key={`header-${index}`}
                variant="text"
                height={24}
                width="100%"
              />
            ))}
          </Stack>

          <Divider />

          {/* Table Rows */}
          {Array.from({ length: TABLE_ROWS }).map((_, rowIndex) => (
            <Stack
              key={`row-${rowIndex}`}
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{ py: 1 }}
            >
              {Array.from({ length: TABLE_COLUMNS }).map((_, colIndex) => (
                <Skeleton
                  key={`cell-${rowIndex}-${colIndex}`}
                  variant="text"
                  height={20}
                  width="100%"
                />
              ))}
            </Stack>
          ))}

          {/* Pagination */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Skeleton variant="text" width={120} height={24} />
          </Box>
        </Card>

        {/* -------- RIGHT: UPLOAD PANEL -------- */}
        <Card className="!rounded-xl" sx={{ flex: 1.5, p: 3 }}>
          <Skeleton variant="text" width={160} height={48} />
          <Skeleton variant="text" width={260} height={36} className="mb-4" />

          <Divider className="mb-4" />
          <Stack spacing={3}>
            <Skeleton variant="rounded" height={48} className="mb-6" />

            {/* Document Type */}
            <Skeleton variant="rectangular" height={48} />

            {/* Drag & Drop Area */}
            <Box
              sx={{
                border: '1px dashed #cfcfcf',
                borderRadius: 1,
                p: 4,
                textAlign: 'center',
              }}
            >
              <Skeleton
                variant="rectangular"
                width={48}
                height={48}
                sx={{ mx: 'auto', mb: 2 }}
              />
              <Skeleton width="75%" sx={{ mx: 'auto' }} />
            </Box>

            {/* Executive dropdown */}
            <Skeleton variant="rectangular" height={48} />

            {/* Upload Button */}
            <Skeleton variant="rectangular" height={42} />
          </Stack>
        </Card>
      </Box>
    </Box>
  );
};
